define('view/disclosure/modals/disclosure.comment.modal',['require','exports','module','underscore','uikit/uikit','blockit','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _       = require('underscore'),
      UIKit   = require('uikit/uikit'),
      BlocKit = require('blockit'),
      Radio   = require('backbone.radio');

  var disclosureCommentModal = UIKit.Modal2.extend({
    className: 'ui modal confirmation',
    options: _.extend({}, UIKit.Modal2.prototype.options, {
      //tried using closeable per modal2 documentation - did not work
      closable: true,
    }),
    header: {
      type: UIKit.Modal2.HeaderView,
      text: 'Notes',
    },

    content: function() {
      return {
        type: UIKit.Modal2.ContentView,
        components: [
          {
            type: UIKit.Text,
            text: function() {
              var disclosureChannel = Radio.channel('disclosureChannel');
              var reviewerComment = disclosureChannel.request('reviewer:comment');
              return reviewerComment;
            },
          },
        ],
      };
    },
    actions: {
      components: [
        {
          type: UIKit.Modal2.DenyButtonView,
          text: 'Close',
        },
      ],
    },
  });

  module.exports = disclosureCommentModal;
});

